import React from 'react';
import './Content.css';
import ParticleHeaderBg from '../ParticlesBg/ParticlesHeader/ParticleHeaderBg';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-scroll';

// Social media data for easier management and to prevent code duplication
const socialLinks = [
    { id: 'linkedin', url: 'https://www.linkedin.com/in/arun-singh-5a0237303', icon: 'fab fa-linkedin', delay: '1200' },
    { id: 'github', url: 'https://github.com/', icon: 'fab fa-github', delay: '1400' },
    { id: 'instagram', url: 'https://www.instagram.com/arun_ch0udhary_/', icon: 'fab fa-instagram', delay: '1600' },
    { id: 'whatsapp', url: 'https://api.whatsapp.com/send?phone=918082065540', icon: 'fab fa-whatsapp', delay: '1800' },
];

// Reusable component for social media links
const SocialLinks = ({ className, links }) => (
    <div className={className}>
        {links.map(link => (
            <a
                key={link.id}
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                data-aos="fade-up"
                data-aos-delay={link.delay}
            >
                <i className={link.icon}></i>
                {className === 'wrapper' && <span>{link.id.charAt(0).toUpperCase() + link.id.slice(1)}</span>}
            </a>
        ))}
    </div>
);

// Main content component
const Content = () => (
    <div className="contenido">
        <ParticleHeaderBg />
        <section className="inicio" id="inicio">
            <div className="titulo">
                <p data-aos="fade-up" data-aos-delay="600">
                    <FormattedMessage id='greeting' defaultMessage='Hello' />
                </p>
                <h1 data-aos="fade-up" data-aos-delay="800">
                    <FormattedMessage id='name' defaultMessage='I am Arun Singh' />
                </h1>
                <p data-aos="fade-up" data-aos-delay="1000">
                    <FormattedMessage id='rol' defaultMessage='Python Full-stack & Web developer' />
                </p>

                {/* Using a single reusable component for both layouts */}
                <SocialLinks className="redes-sociales" links={socialLinks} />

                <div className="wrapper">
                    {socialLinks.map(link => (
                        <a
                            key={link.id}
                            className="button"
                            href={link.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-aos="fade-up"
                            data-aos-delay={link.delay}
                        >
                            <div className="icon">
                                <i className={link.icon}></i>
                            </div>
                            <span>{link.id.charAt(0).toUpperCase() + link.id.slice(1)}</span>
                        </a>
                    ))}
                </div>

                <Link to="sobre-mi" href="#sobre-mi">
                    <div className="scroll-down"></div>
                </Link>
            </div>
        </section>
    </div>
);

export default Content;